
import React, { useState } from 'react';
import { Car } from '@/contexts/CarContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Share } from 'lucide-react';
import ShareLinkManager from './ShareLinkManager';

interface ShareLinkSectionProps {
  car: Car;
}

const ShareLinkSection: React.FC<ShareLinkSectionProps> = ({ car }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Card className="mt-6">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-xl">Share with Mechanic</CardTitle>
            <CardDescription>
              Create a secure link to share with your mechanic
            </CardDescription>
          </div>
          <Button 
            variant="outline" 
            size="sm" 
            className="flex items-center gap-1"
            onClick={() => setIsOpen(!isOpen)}
          >
            <Share size={16} />
            {isOpen ? 'Hide' : 'Manage Links'}
          </Button>
        </div>
      </CardHeader>
      
      {isOpen && (
        <CardContent>
          <ShareLinkManager car={car} />
        </CardContent>
      )}
    </Card>
  );
};

export default ShareLinkSection;
